// Media kit / brand partnerships page content (shelbyfloral.com/partnerships).
// Edit anything here — stats, list items, tags, contact details, even the
// title/description used for link previews — and both the live page and
// the printable preview pick it up. No other file needs to change.
const mediaKitData = {
	meta: {
		title: "Shelby Floral — Brand Partnerships & Media Kit",
		description:
			"Shelby turns the real work behind beautiful events into short-form content. Utah wedding florist and creator — audience momentum, partnership opportunities, and contact details for brands.",
		// Used for link-preview cards (iMessage, Slack, email). Relative to the site root.
		ogImage: "/images/portfolio/IMG_8989.JPG",
	},
	header: {
		eyebrow: "Brand partnerships · Media kit · August 2026",
		title: "Shelby Floral",
		role: "Creator & Utah wedding florist",
		image: "/images/portfolio/IMG_8989.JPG",
		handles: [
			{ label: "@shelbyfloral", href: "https://www.instagram.com/shelbyfloral/" },
			{ label: "shelbyfloral.com", href: "/" },
			{ label: "Utah", href: null },
		],
	},
	intro:
		"Shelby turns the real work behind beautiful events into short-form content. Her audience comes for the flowers, then stays for the process, the small-business story, and the person behind the designs.",
	stats: [
		{ value: "15K+", label: "Instagram followers, growing" },
		{ value: "14M+", label: "Views across two breakout reels" },
		{ value: "350K+", label: "Views on one BTS reel" },
		{ value: "3×", label: "Audience growth in August" },
	],
	featuredIn: {
		outlet: "PEOPLE",
		description:
			"National coverage of Shelby's viral ski-lift wedding setup at Sundance Mountain Resort.",
	},
	whyItWorks: {
		headline: "Beautiful visuals get attention. The real process builds connection.",
		body: "Shelby's strongest growth has come from behind-the-scenes content showing the logistics, creativity, physical work, and business behind the final arrangement.",
	},
	opportunities: [
		"Integrated Reels and short-form storytelling",
		"Product demonstrations in real workflow",
		"Wedding and event integrations",
		"UGC packages for brand-owned channels",
		"Affiliate partnerships and recommendations",
		"Giveaways and audience activations",
	],
	brandCategories: [
		"Floral tools, supplies, vases and containers",
		"Home, decor and organization",
		"Workwear, footwear and accessories",
		"Wedding, lifestyle and consumer brands",
	],
	contentTags: [
		"Behind the scenes",
		"Flowers + home",
		"Weddings",
		"Small business",
		"Workwear",
		"Tools + organization",
		"Lifestyle",
		"Local Utah",
	],
	closer: {
		headline: "Let's collaborate.",
		email: "shelby@shelbyfloral.com",
		website: "www.shelbyfloral.com",
	},
};

module.exports = mediaKitData;
